import { Validators } from "@angular/forms";
import { debounceTime, filter } from 'rxjs';
import { SzamlazzhuInvoicesForm } from "../form.controls";
import { FormFactory, SZAMLAZZHU_INVOICES_FORM_NAME } from "../form.factory";
import { SzamlazzhuInvoice } from "../form.resources";
import { SyncSzamlazzhuInvoicesParams } from "../form.service";
import { totalAmountValidator } from "../validators/total-amount";

export function getSzamlazzhuInvoicesForm(this: FormFactory): SzamlazzhuInvoicesForm {
  const data = this.data as SzamlazzhuInvoice[];

  const form = this.fb.array(
    data.map(invoice => {
      const ff = new FormFactory(
        this.formService,
        this.fb,
        invoice,
      );
      return ff.getSzamlazzhuInvoiceForm();
    }),
    [Validators.required, totalAmountValidator(
      'total_remaining_amount',
      'currency_iso',
      this.formService,
    )],
  );

  this.formService.saving.subscribe({
    next: s => {
      if (s > 0) {
        form.disable({ onlySelf: true, emitEvent: false });
      } else {
        form.enable({ onlySelf: true, emitEvent: false });
      }
    }
  });

  form.statusChanges
    .pipe(
      debounceTime(1000),
      filter(s => s === 'VALID'),
    )
    .subscribe({
      next: async () => {
        try {
          const szamlazzhuInvoices = form.getRawValue();
          const params: SyncSzamlazzhuInvoicesParams = {
            invoices: szamlazzhuInvoices.map(invoice => ({
              invoice_id: invoice.invoice_id,
              file: invoice.file instanceof File ? invoice.file : null,
            })),
          };
          const invoices = await this.formService.syncSzamlazzhuInvoices(params);
          for (const invoice of invoices) {
            const formGroup = form.controls.find(control => control.value.invoice_id === invoice.invoice_id);
            if (formGroup) {
              formGroup.patchValue(invoice, { emitEvent: false });
            }
          }
          this.trackValidForm(SZAMLAZZHU_INVOICES_FORM_NAME);
        } catch (error) {
          console.error('Error while syncing invoices', error);
        }
      }
    });

  return form;
}
